import React, { useState, useCallback, useEffect, useRef } from "react";
import cn from "classnames";
import { useLocation } from "react-router-dom";
import styles from "./ChargerList.module.scss";
import ChargerTable from "components/mychargers_component/ChargerTable";
// import Multiselect from 'multiselect-react-dropdown';
import Gauge from "../echarts/Gauge";
import LineGraph from "../echarts/LineGraph";
import Donut from "../echarts/Donut";
import CustomDropDown from "components/CustomDropDown";
import {
  getRequest,
  postRequest,
  getMockyRequest,
} from "../../services/axiosBaseClient";
import {
  timeDiffCalc,
  dateFormate,
  dateFormateToMeridiem,
  dateFormateFleet,
} from "../timeDiffCalc";

import { useSelector, useDispatch } from "react-redux";

import { fetchSiteList, getSiteList, addTodoAsync } from "redux/siteSlice";
import { getChargerTableList } from "redux/chargerTableSlice";
import {
  fetchChargerList,
  getChargerList,
  chargerdropdownTodoAsync,
} from "redux/chargerSlice";
import qs from "query-string";
import { color } from "echarts";
import PopUp from "./PopUp";
import ChargerDropDown from "components/ChargerDropdown";
import { TableContext } from "./ChargerTable";

const colorsArray = [
  { name: "charging", color: "#6A9930" },
  { name: "connected", color: "#73CEE5" },
  { name: "discharging", color: "#0077C0" },
  { name: "plugged", color: "#73CEE5" },
  { name: "available", color: "#BFC9D5" },
  { name: "alert", color: "#A23B3E" },
  { name: "offline", color: "#565656" },
  { name: "down", color: "#A23B3E" },
  { name: "up", color: "#CDDC38" },
];

export default function ChargerList(props) {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  if (splitLocation[1] !== "myFleet") {
    localStorage.removeItem("fleetShorting");
    localStorage.removeItem("selectedId");
  }

  var chargerTableData = useSelector(getChargerTableList);
  const firstRender = useRef(true);

  var [selectedId, setSelectedId] = useState(chargerTableData);
  // console.log('text',chargerTableData)
  var siteListData = useSelector(getSiteList);
  function getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }

  const arr1 = getUniqueListBy(siteListData, "siteID");

  var chargerListData = useSelector(getChargerList);
  const chargerDataL = chargerListData;
  // console.log('charger', chargerDataL)
  const dispatch = useDispatch();
  const [siteMultiSelect, setSiteMultiSelect] = useState(siteListData);
  var [chargerMultiSelect, setChargerMultiSelect] = useState(chargerListData);
  var [selectedList, selectedItem] = useState();
  const [checkCharging, setCheckCharging] = useState(null);
  const [checkDischaring, setCheckDischaring] = useState(null);
  const [isApiCalling, setApiCalling] = useState(false);
  // const [slestedData, setSelecteddata] = useState()
  // const [bool1, setBool1] = useState(true)
  let [chargerSelected, setChargerSelected] = useState();
  const filterData = (data) => {
    selectedItem(data);
  };

  const filterChargerData = (data) => {
    setChargerSelected(data);
  };

  let arrList = [{ label: "Select All", value: "0" }];
  if (selectedList !== undefined) {
    if (selectedList?.length > 0) {
      for (let i = 0; i < selectedList?.length; i++) {
        arrList.push({
          label: selectedList[i].label,
          value: selectedList[i].value,
          siteId: selectedList[i]?.siteID,
        });
      }
    }
    chargerListData = chargerListData?.filter((obj) =>
      arrList?.some(({ siteId }) => obj?.siteId === siteId)
    );
  }
  if (selectedList?.length === 0) {
    let siteList = selectedList;
    // JSON.parse(localStorage.getItem('filterSite'));
    if (siteList?.length > 0) {
      for (let i = 0; i < siteList?.length; i++) {
        arrList.push({
          label: siteList[i].label,
          value: siteList[i].value,
          siteId: siteList[i].siteID,
        });
      }
      chargerListData = chargerDataL?.filter((obj) =>
        arrList?.some(({ siteId }) => obj?.siteId === siteId)
      );
    } else {
      chargerListData = chargerDataL;
    }
  }

  const evsesArray = [];

  const selectedRecord = (data) => {
    if (data?.length > 0) {
      donnutGraphData(data);
    }
    data?.map((val) => {
      if (evsesArray?.indexOf(val?.id) > -1) {
        evsesArray.push(val?.id);
      }
    });
  };

  const selectChargingFilter = useCallback((data) => {
    setCheckCharging(data);
  });

  const selectDischargingFilter = useCallback((data) => {
    setCheckDischaring(data);
  });

  var alertData = "";
  let chargerData = [];
  var statusCount = [];
  const [chargerFinalData, setchargerFinalData] = useState([]);
  const [realTimeData, setRealTimeData] = useState([]);
  const [energyBalanceData, setEnergyBalanceData] = useState({});
  const [donutGraphData, setDonutGraphData] = useState([]);
  const [outerSideClick, setOuterSideClick] = useState(true);
  const [outerSideClick1, setOuterSideClick1] = useState(true);
  const [checkAlert, setCheckAlert] = useState([]);
  const [selectAlert, setSelectAlert] = useState(false);
  const [powerPopup, setPowerPopup] = useState(false);

  var realId = "";
  let chargerDetails;
  const getChargerData = async () => {
    var evsesID = siteListData
      .slice(1)
      .map(function (e) {
        return e?.evseId;
      })
      .join(",");
    // chargerDetails=await getMockyRequest('https://run.mocky.io/v3/d4257e84-8d9d-47d4-927a-8d1e987ef50c').then((res) => {
    chargerDetails = await getRequest("evses/details?evseIds=" + evsesID).then(
      (res) => {
        var realtimeId = res?.data?.fullDetails?.map((e) => {
          if (e.evseDetails?.id !== undefined) {
            return e.evseDetails?.id;
          }
        });
        for (let i = 0; i < realtimeId.length; i++) {
          if (realtimeId[i] !== undefined) {
            realId += realtimeId[i] + ",";
          }
        }

        return res;
        // return evs
      }
    );
    if (!isApiCalling) {
      if (window?.location?.href?.includes("myChargers")) {
        setApiCalling(true);
        getRealTimePower();
      }
    }

    // if (!isApiCalling){

    //   setInterval(() => {
    //     if(window?.location?.href?.includes('myChargers')){
    //       setApiCalling(true);
    //       getRealTimePower();
    //     }
    //   }, 5000);
    //   }
  };

  window.addEventListener("click", function (e) {
    // console.log(e.target)
    if (
      e &&
      e.target &&
      document.getElementById("chargerClickbox")?.contains(e.target)
    ) {
      setOuterSideClick(true);
    } else {
      setOuterSideClick(false);
    }

    if (
      e &&
      e.target &&
      document.getElementById("chargerClickbox1")?.contains(e.target)
    ) {
      setOuterSideClick1(true);
    } else {
      setOuterSideClick1(false);
    }
  });
  const realtimeApi = async (endStr, startStr, evscId) => {
    await getRequest(
      "evses/real-time?from=" +
        endStr +
        "&to=" +
        startStr +
        "&evseIds=" +
        evscId
    ).then((resData) => {
      if (resData?.status === 200) {
        // debugger
        getRealTimePower();
      }
    });
  };

  const checkCall = () => {
    setTimeout(() => {
      if (!isApiCalling) {
        if (window?.location?.href?.includes("myChargers")) {
          setApiCalling(false);
          getRealTimePower();
        }
      }
    }, 5000);
  };

  const getRealTimePower = async () => {
    chargerData = [];
    const fromDate = new Date();
    const startStr = fromDate.toISOString();
    const toDate = addMinutes(30);
    const estr = new Date(toDate);
    const endStr = estr.toISOString();
    // const searchString = qs.stringify({ from: a, to: toDate });
    const evscId = realId.replace(/,\s*$/, "");
    // let chargerRealTime = await getMockyRequest('https://run.mocky.io/v3/a4eaae09-7d04-416c-bf6c-0ef8e5376787').then((resData) => {
    let chargerRealTime;

    chargerRealTime = await getRequest(
      "evses/real-time?from=" +
        endStr +
        "&to=" +
        startStr +
        "&evseIds=" +
        evscId
    ).then((resData) => {
      if (resData?.status === 200) {
        if (!isApiCalling) {
          setApiCalling(false);
          if (window?.location?.href?.includes("myChargers")) {
            checkCall();
          }
        }
        return resData;
      }
    });

    var res = chargerRealTime;

    // let fullDetaitsArray = chargerDetails.data.fullDetails
    let fullDetaitsArray = chargerDetails?.data?.fullDetails;
    let timeZoneArr = JSON.parse(localStorage.getItem("timezone"));
    if (res) {
      fullDetaitsArray.map((item) => {
        let objIndex = res?.data?.data?.findIndex(
          (obj) => obj?.evseId === item?.evseDetails?.id
        );

        const colorCode = colorsArray.find(
          (obj) =>
            obj?.name === res?.data?.data[objIndex]?.status?.toLocaleLowerCase()
        )?.color;

        const sessionTime = timeDiffCalc(
          new Date(),
          new Date(item.transactionDetails?.started)
        );

        let getSiteAdd = siteListData.find((obj) => {
          if (obj?.evseId === item?.evseDetails?.id) {
            return obj?.label;
          }
        });

        let getAddress = siteListData.find((obj) => {
          if (obj?.evseId === item?.evseDetails?.id) {
            return obj?.address;
          }
        });

        let getstatus = res?.data?.data?.find((obj) => {
          if (obj?.evseId === item?.evseDetails?.id) {
            return obj;
          }
        });

        let statusValue = getstatus?.status;

        let siteList = getSiteAdd?.label === undefined ? "" : getSiteAdd?.label;
        let siteAdd =
          getSiteAdd?.address === undefined ? "" : getSiteAdd?.address;
        let siteID = getSiteAdd?.siteID === undefined ? "" : getSiteAdd?.siteID;

        let objrealTime = res?.data?.data?.find((val) => {
          if (item?.evseDetails?.id === val.evseId) {
            return res?.data;
          }
        });
        // debugger
        let realSoc = objrealTime?.soc === undefined ? "" : objrealTime?.soc;
        let realTimePower =
          objrealTime?.realTimePower === undefined
            ? ""
            : (objrealTime?.realTimePower / 1000) * -1 + " kW";

        let timeZone;
        if (timeZoneArr !== undefined) {
          timeZone = timeZoneArr?.find((val) => {
            // debugger
            if (val.value === item?.evseDetails?.id) {
              return timeZoneArr;
            }
          });
        }
        let chargerTimeZone =
          timeZone?.timeZone !== undefined ? timeZone?.timeZone : "";
        var chargerdate =
          item?.socRequirement?.startsAt !== undefined
            ? item?.socRequirement?.startsAt
            : "";
        let dateTime = dateFormateFleet(chargerdate, chargerTimeZone);

        chargerData.push({
          transactionId: item?.transactionDetails?.id,
          statusName:
            statusValue !== undefined ? statusValue.toLocaleLowerCase() : "",
          color: colorCode,
          // charger: { name: item?.evseDetails?.name, port: item?.evseDetails?.model?.displayName, chargerID: item?.evseDetails?.id },
          //  charger: { name: item.evseDetails.name, port: item.evseDetails.modelId, chargerID: item?.evseDetails?.id }, //this code commented on 17 Aug by client feedback
          charger: {
            name: item?.evseDetails?.name,
            port: item?.evseDetails?.model?.displayName,
            chargerID: item?.evseDetails?.id,
          },
          // status: { error1: item?.evseDetails.status?.toLocaleLowerCase(), type: item?.evseDetails?.status },
          // status: {error1: item?.evseStatus?.toLocaleLowerCase(), type: item?.evseStatus},
          // status: { error1: res?.evseStatusData[objIndex]?.evseStatus, type: res?.evseStatusData[objIndex]?.evseStatus },
          status: {
            error1: statusValue !== undefined ? statusValue : "",
            type: statusValue !== undefined ? statusValue : "",
          },
          vehicle: {
            name: item?.vehiclesDetails?.name,
            model: item.vehiclesDetails?.modelDisplayName,
          },
          soc: {
            current: realSoc,
            target: item?.socRequirement?.soc,
            color: colorCode,
          },
          site: { list: siteList, address: siteAdd, siteId: siteID },
          readyBy: calReadyBy(
            item?.socRequirement?.soc === undefined
              ? ""
              : item?.socRequirement?.soc,
            res?.data?.data[objIndex]?.soc,
            res?.data?.data[objIndex]?.realTimePower,
            item?.vehiclesDetails?.model?.batteryCapacity,
            chargerTimeZone,
            item?.socRequirement?.startsAt !== undefined
              ? item?.socRequirement?.startsAt
              : ""
          ),
          // nextTrip: { date: dateFormate(item?.socRequirement?.startsAt), error: false },
          nextTrip: { date: dateTime, error: false },
          // realTimePower: res?.evseData[objIndex]?.realTimePower ? (res?.evseData[objIndex]?.realTimePower/1000)*-1 + ' kW' : '',
          realTimePower: realTimePower,

          sessionNetEnergy: calSessionNetEnergy(
            res?.data?.data[objIndex]?.soc,
            item?.transactionDetails?.startSoc,
            item?.vehiclesDetails?.model?.batteryCapacity
          ),
          sessionTime: sessionTime,
          setChargingTime: {
            name:
              res?.data?.data[objIndex]?.transactionMode === "SMART_CHARGING"
                ? "Manual Charge"
                : res?.data?.data[objIndex]?.transactionMode ===
                    "INSTANT_CHARGING" &&
                  item?.socRequirement?.startsAt !== undefined &&
                  item?.socRequirement?.startsAt !== ""
                ? "Back To Scheduled"
                : res?.data?.data[objIndex]?.transactionMode ===
                  "INSTANT_CHARGING"
                ? "Stop Charge"
                : "",
            color:
              res?.data?.data[objIndex]?.transactionMode === "SMART_CHARGING"
                ? "#A23B3E"
                : res?.data?.data[objIndex]?.transactionMode ===
                    "INSTANT_CHARGING" &&
                  item?.socRequirement?.startsAt !== undefined &&
                  item?.socRequirement?.startsAt !== ""
                ? "#0077C0"
                : res?.data?.data[objIndex]?.transactionMode ===
                  "INSTANT_CHARGING"
                ? "#73CEE5"
                : "",
          },
          // setChargingTime: { name: res?.data?.data[objIndex]?.transactionMode === 'INSTANT_CHARGING' ? 'Manual Charge' : res?.data?.data[objIndex]?.transactionMode === 'SMART_CHARGING' && (item?.socRequirement?.startsAt !== undefined && item?.socRequirement?.startsAt !== '') ? 'Back To Scheduled' : 'Stop Charge', color: colorCode },
          // setChargingTime: { name:  res?.data?.data[objIndex]?.transactionMode === 'INSTANT_CHARGING' ? 'Manual Charge':res?.data?.data[objIndex]?.transactionMode === 'SMART_CHARGING' ? 'Stop Charge' : 'Back To Scheduled', color: colorCode },
          // setChargingTime: { name: res?.data?.data[objIndex]?.status === 'UP' ? 'Manual Charge' : res?.data?.data[objIndex]?.status === 'PLUGGED' ? 'Manual Charge' : res?.data?.data[objIndex]?.status === 'CHARGING' && (item?.socRequirement?.startsAt !== undefined && item?.socRequirement?.startsAt !== '') ? 'Back To Scheduled' : res?.data?.data[objIndex]?.status === 'CHARGING' && (item?.socRequirement?.soc === undefined || item?.socRequirement?.soc === '') ? 'Stop Charge' : res?.data?.data[objIndex]?.status === 'DISCHARGING' ? 'Back To Scheduled' : '', color: colorCode },

          // setChargingTime: { name: res?.evseStatusData[objIndex]?.evseStatus === 'UP' ? 'Manual Charge' : res?.evseStatusData[objIndex]?.evseStatus === 'PLUGGED' ? 'Manual Charge' : res?.evseStatusData[objIndex]?.evseStatus === 'CHARGING' && (item?.socRequirement?.startsAt !== undefined && item?.socRequirement?.startsAt !== '') ? 'Back To Scheduled' : res?.evseStatusData[objIndex]?.evseStatus === 'CHARGING' && (item?.socRequirement?.soc === undefined || item?.socRequirement?.soc === '') ? 'Stop Charge' : res?.evseStatusData[objIndex]?.evseStatus === 'DISCHARGING' ? 'Back To Scheduled' : '', color: colorCode },
          // setChargingTime: { name: res?.evseStatusData[objIndex]?.evseStatus === 'UP' ? 'Manual Charge' : res?.evseStatusData[objIndex]?.evseStatus === 'PLUGGED' ? 'Manual Charge' : res?.evseStatusData[objIndex]?.evseStatus === 'CHARGING' && (item?.socRequirement?.soc !== undefined && item?.socRequirement?.soc !== '') ? 'Back To Scheduled' : res?.evseStatusData[objIndex]?.evseStatus === 'CHARGING' && (item?.socRequirement?.soc === undefined || item?.socRequirement?.soc === '') ? 'Stop Charge' :res?.evseStatusData[objIndex]?.evseStatus === 'DISCHARGING' ? 'Back To Scheduled' :'', color: colorCode },
          startSoc: item?.socRequirement?.soc,
          batteryCapacity: item.vehiclesDetails?.model?.batteryCapacity,
          id: item?.evseDetails?.id,
          tripChargePower:
            item?.evseDetails?.model?.powerLimits?.maxChargePower !== undefined
              ? item?.evseDetails?.model?.powerLimits?.maxChargePower * -1
              : "",
          errorCount: 0,
          chargingPower: 0,
          disChargingPower: 0,
          timezone: chargerTimeZone,
        });
      });
      if (res) {
        chargerData.map((val, index) => {
          let objIndex = res?.data?.data?.findIndex(
            (obj) => obj?.evseId === val?.id
          );
          if (
            new Date(val?.nextTrip?.date).getTime() <
            new Date(val?.readyBy).getTime()
          ) {
            chargerData[0].errorCount = chargerData[0]?.errorCount + 1;
            val.nextTrip.error = true;
          }
          if (res?.data?.data[objIndex]?.realTimePower !== undefined) {
            if (parseInt(res?.data?.data[objIndex]?.realTimePower) > 0) {
              chargerData[0].disChargingPower =
                chargerData[0]?.disChargingPower +
                res?.data?.data[objIndex]?.realTimePower / 1000;
            } else {
              chargerData[0].chargingPower =
                chargerData[0]?.chargingPower +
                res?.data?.data[objIndex]?.realTimePower / 1000;
            }
          }
        });
      }
    } else {
      fullDetaitsArray.map((item) => {
        const colorCode = colorsArray.find(
          (obj) => obj?.name === item?.evseStatus?.toLocaleLowerCase()
        )?.color;

        const sessionTime = timeDiffCalc(
          new Date(),
          new Date(item.evseDetails.currentTransaction?.started)
        );
        let getSiteAdd = arr1.find((obj) => {
          if (obj?.evseId === item?.evseDetails?.id) {
            return obj?.label;
          }
        });

        let siteList = getSiteAdd?.label === undefined ? "" : getSiteAdd?.label;
        chargerData.push({
          transactionId: item?.evseDetails?.currentTransaction?.id,
          statusName: item?.evseStatus?.toLocaleLowerCase(),
          color: colorCode,
          charger: {
            name: item.evseDetails.name,
            port: item.evseDetails.model?.id,
            chargerID: item?.evseDetails?.id,
          },
          // status: { error1: item?.evseDetails.status.toLocaleLowerCase(), type: item?.evseDetails?.status },
          status: {
            error1: item?.evseStatus?.toLocaleLowerCase(),
            type: item?.evseStatus,
          },
          vehicle: {
            name: item?.vehiclesDetails?.name,
            model: item.vehiclesDetails?.modelDisplayName,
          },
          soc: {
            current: "",
            target: item.socRequirement?.soc,
            color: colorCode,
          },
          site: siteList,
          readyBy: "",
          // nextTrip: { date: dateFormate(item?.socRequirement?.startsAt), error: false },
          realTimePower: "",
          sessionNetEnergy: "",
          sessionTime: sessionTime,
          setChargingTime: {
            name:
              item?.evseStatus === "UP"
                ? "Manual Charge"
                : item?.evseStatus === "plugged"
                ? "Manual Charge"
                : item?.evseStatus === "charging" &&
                  item?.socRequirement?.soc !== undefined &&
                  item?.socRequirement?.soc !== ""
                ? "Back To Scheduled"
                : "",
            color: colorCode,
          },
          startSoc: item?.socRequirement?.soc,
          batteryCapacity: item.vehiclesDetails?.model?.batteryCapacity,
          id: item?.evseDetails?.id,
          errorCount: 0,
          chargingPower: 0,
          disChargingPower: 0,
        });
        // donnutGraphData(chargerData)
      });
    }
    donnutGraphData(chargerData);
    setchargerFinalData(chargerData);
    // setDonutGraphData(statusCount);
    setRealTimeData(chargerData);
    const EBalanceTime = [];
    const EBalance = [];
    if (res?.data?.energyBalances) {
      res?.data?.energyBalances?.map((val, index) => {
        EBalance.push((val?.totalActivePower / 1000) * -1);
        EBalanceTime.push(dateFormateToMeridiem(val.time));
      });
      setEnergyBalanceData({ balance: EBalance, time: EBalanceTime });
    }
  };

  const calSessionNetEnergy = (currentSoc, startSoc, batteryCapacity) => {
    if (
      currentSoc === undefined ||
      startSoc === undefined ||
      batteryCapacity === undefined
    ) {
      return "";
    } else {
      return (
        (
          ((currentSoc / 100 - startSoc / 100) * batteryCapacity) /
          1000
        ).toFixed(1) + " kWh"
      );
    }
  };

  const calReadyBy = (
    targetSoc,
    currentSoc,
    realTimePower,
    batteryCapacity,
    chargerTimeZone,
    nesTrip
  ) => {
    // debugger
    if (targetSoc === undefined && currentSoc === undefined) {
      return "";
    } else {
      if (currentSoc >= targetSoc) {
        if (currentSoc > 0) {
          if (nesTrip !== "") {
            return "Ready";
          } else {
            return "";
          }
        } else {
          return "";
        }
      } else if (realTimePower >= 0) {
        return "";
      } else {
        if (
          targetSoc !== undefined &&
          currentSoc !== undefined &&
          realTimePower !== undefined &&
          batteryCapacity !== undefined
        ) {
          // return dateFormate(new Date() + Math.ceil((targetSoc - currentSoc) / 100 * batteryCapacity / (realTimePower * -1000) * 60));
          return dateFormateFleet(
            new Date() +
              Math.ceil(
                ((((targetSoc - currentSoc) / 100) * batteryCapacity) /
                  (realTimePower * -1000)) *
                  60
              ),
            chargerTimeZone
          );
        } else {
          return "";
        }
      }
    }
  };

  // function addHours(minutes, date = new Date()) {
  //   // date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
  //   return date.setTime(date.getTime() + minutes*60000);
  //   // return date;
  // }
  function addMinutes(minutes, date = new Date()) {
    // date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
    return date.setTime(date.getTime() - minutes * 60000);
    // return date;
  }

  useEffect(() => {
    dispatch(addTodoAsync(siteMultiSelect));
    return () => {
      setchargerFinalData([]);
      setRealTimeData([]);
      setEnergyBalanceData({});
      setDonutGraphData([]);
      setOuterSideClick(true);
      setOuterSideClick1(true);
      setSelectAlert(false);
      setPowerPopup(false);
    };
  }, []);
  useEffect(() => {
    dispatch(chargerdropdownTodoAsync(chargerMultiSelect));
  }, []);

  const alertError = (e) => {
    setCheckAlert(e);
    setSelectAlert(!selectAlert);
  };
  checkAlert.map((val) => {
    if (val.statusName !== "alert") {
      return val;
    }
    alertData = val.statusName;
  });
  const powerBalancePopup = () => {
    setPowerPopup(!powerPopup);
  };

  const donnutGraphData = (data) => {
    let donutData = data?.map((val) => {
      return { value: 1, name: val.statusName, color: val.color };
    });
    var statusData = [];
    var errorCounts = 0;
    var chargingCounts = 0;
    var dischargingCounts = 0;
    var pluggedCounts = 0;
    var chargedCounts = 0;
    var downCounts = 0;
    var upCounts = 0;
    var offlineCounts = 0;
    statusCount = [];
    function capitalize(input) {
      return input?.toLowerCase();
    }

    donutData?.map((val) => {
      capitalize(val?.name) === "alert" ? errorCounts++ : (errorCounts += 0);
      capitalize(val?.name) === "charging"
        ? chargingCounts++
        : (chargingCounts += 0);
      capitalize(val?.name) === "discharging"
        ? dischargingCounts++
        : (dischargingCounts += 0);
      capitalize(val?.name) === "plugged"
        ? pluggedCounts++
        : (pluggedCounts += 0);
      capitalize(val?.name) === "available"
        ? chargedCounts++
        : (chargedCounts += 0);
      capitalize(val?.name) === "down" ? downCounts++ : (downCounts += 0);
      capitalize(val?.name) === "up" ? upCounts++ : (upCounts += 0);
      capitalize(val?.name) === "offline"
        ? offlineCounts++
        : (offlineCounts += 0);
    });

    for (let i = 0; i < donutData?.length; i++) {
      if (!statusData.includes(donutData[i].name)) {
        statusData.push(donutData[i].name);

        statusCount.push({
          value:
            donutData[i]?.name === "charging"
              ? chargingCounts
              : donutData[i]?.name === "alert"
              ? errorCounts
              : donutData[i].name === "discharging"
              ? dischargingCounts
              : donutData[i]?.name === "plugged"
              ? pluggedCounts
              : donutData[i]?.name === "available"
              ? chargedCounts
              : donutData[i]?.name === "down"
              ? downCounts
              : donutData[i]?.name === "up"
              ? upCounts
              : donutData[i]?.name === "offline"
              ? offlineCounts
              : "",
          name:
            donutData[i]?.name === "offline"
              ? donutData[i]?.name + " " + offlineCounts
              : donutData[i]?.name === "charging"
              ? donutData[i]?.name + " " + chargingCounts
              : donutData[i]?.name === "alert"
              ? donutData[i]?.name + " " + errorCounts
              : donutData[i].name === "discharging"
              ? donutData[i]?.name + " " + dischargingCounts
              : donutData[i]?.name === "plugged"
              ? donutData[i]?.name + " " + pluggedCounts
              : donutData[i]?.name === "available"
              ? donutData[i]?.name + " " + chargedCounts
              : donutData[i]?.name === "down"
              ? "disconnected" + " " + downCounts
              : donutData[i]?.name === "up"
              ? "connected" + " " + upCounts
              : "",
          color: donutData[i].color,
          count:
            donutData[i]?.name === "offline"
              ? offlineCounts
              : donutData[i]?.name === "charging"
              ? chargingCounts
              : donutData[i]?.name === "alert"
              ? errorCounts
              : donutData[i].name === "discharging"
              ? dischargingCounts
              : donutData[i]?.name === "plugged"
              ? pluggedCounts
              : donutData[i]?.name === "available"
              ? chargedCounts
              : donutData[i]?.name === "down"
              ? downCounts
              : donutData[i]?.name === "up"
              ? upCounts
              : "",
          // colorName: donutData[i]?.name === 'charging' ? 'charging' : donutData[i]?.name === 'alert' ? 'alert' : donutData[i].name === 'discharging' ? 'discharging' : donutData[i]?.name === 'plugged' ? 'plugged' : donutData[i]?.name === 'available' ? 'available' : donutData[i]?.name === 'down' ? 'down' : donutData[i]?.name === 'up' ? 'up' : donutData[i]?.name === 'offline' ? 'offline' : ''
        });
      }
    }

    if (donutData?.length > 0) {
      // if (selectedList?.length >0) {
      setTimeout(() => {
        donutt();
      }, 800);
      // } else {
      //   setDonutGraphData(statusCount)
      // }
    }
  };
  const donutt = () => {
    setDonutGraphData(statusCount);
  };
  useEffect(async () => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      await getChargerData();
    }
  }, [siteListData]);

  useEffect(async () => {}, [selectedId]);

  // window.addEventListener('resize', function() {
  //   // if (window.innerWidth >= 1200) {
  //     window.location.reload();
  //   // }
  // }, true);

  return (
    <div className={cn("ChargerList", styles.block, styles.block_layout)}>
      <div className={cn(styles.flex, styles.flex_layout)}>
        <div className={cn(styles.flex3, styles.flex3_layout)}>
          <span
            className={cn(styles.flex3, styles.flex3_layout, styles.marLeftTop)}
          >
            <div className={cn(styles.flex3_item)}>
              <div className={cn(styles.block3, styles.block3_layout)}>
                <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                  {"Site: "}
                </h3>
                <div className={cn(styles.block3_spacer)} />
                <div id="chargerClickbox" className={cn(styles.block3_item)}>
                  <CustomDropDown
                    clickCheck={outerSideClick}
                    dropdownData={arr1}
                    chargerCallback={filterData}
                  />
                </div>
                {/* <TableContext.Consumer>
                  {(name) => {
                    return <h1>{name}</h1>;
                  }}
                </TableContext.Consumer> */}
              </div>
            </div>
            <div className={cn(styles.flex3_spacer)} />
            <div className={cn(styles.flex3_item)}>
              <div className={cn(styles.block3, styles.block3_layout)}>
                <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                  {"Charger: "}
                </h3>
                <div className={cn(styles.block3_spacer)} />
                <div id="chargerClickbox1" className={cn(styles.block3_item)}>
                  {/* <CustomDropDown clickCheck={outerSideClick1} dropdownData={chargerListData} chargerCallback={filterData} /> */}
                  {/* second dropdown called for charger here */}
                  <ChargerDropDown
                    clickCheck={outerSideClick1}
                    dropdownData={chargerListData}
                    chargerCallback={filterChargerData}
                  />
                </div>
              </div>
            </div>
          </span>
          <div className={cn(styles.flex3_spacer1)} />
          {/* <div id="chargerClickbox1" className={cn(styles.flex3_item1)}>
            <div className={cn(styles.block2, styles.block2_layout)}>
              <div
                className={cn(styles.cover_block1, styles.cover_block1_layout)}
                onClick={() => props.navState(false)}
              >
                <h3 className={cn(styles.subtitle1, styles.subtitle1_layout)}>
                  {"Layout"}
                </h3>
              </div>

              <div
                className={cn(styles.cover_block, styles.cover_block_layout)}
                onClick={() => props.navState(false)}
              >
                <h3 className={cn(styles.subtitle1, styles.subtitle1_layout)}>
                  {"List"}
                </h3>
              </div>
            </div>
          </div> */}
        </div>

        <div className={cn(styles.flex4, styles.flex4_layout)}>
          <div className={cn(styles.flex4_item)}>
            <div className={cn(styles.box2, styles.box2_layout)}>
              <h5
                className={cn(
                  styles.charger_status_txt,
                  styles.charger_status_txt_layout
                )}
              >
                {"Charger Status"}
              </h5>
              <Donut
                data={donutGraphData}
                className={cn(
                  styles.energy_status_box,
                  styles.energy_status_box_layout
                )}
              />
              {/* <div className={cn(styles.donutTotal)}>
                     <h4>7</h4>
                 </div> */}
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item1)}>
            <div className={cn(styles.box5, styles.box5_layout)}>
              <h5
                className={cn(styles.alerts_1_txt, styles.alerts_1_txt_layout)}
              >
                {"Alerts"}
              </h5>
              <div
                className={cn(styles.alert_cursor_pointer)}
                onClick={(e) => alertError(realTimeData)}
              >
                <img
                  src={require("assets/ic_report.svg").default}
                  alt="Rectangle 5"
                  // onClick={(e) => alertError(realTimeData)}
                  className={cn(styles.alerts_img, styles.alerts_img_layout)}
                />
                <h3
                  className={cn(
                    styles.alerts_2_txt,
                    styles.alerts_2_txt_layout,
                    styles.alert_top_15
                  )}
                >
                  {realTimeData[0]?.errorCount}
                </h3>
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item2)}>
            <div className={cn(styles.box3, styles.box3_layout)}>
              <h5
                className={cn(
                  styles.energy_status_txt,
                  styles.energy_status_txt_layout
                )}
              >
                {"Real-Time Net Power Flow"}
              </h5>
              <div
                //disabling click for 13june
                // onClick={() => powerBalancePopup()}
                style={{ cursor: "pointer" }}
              >
                <LineGraph
                  data={energyBalanceData}
                  className={cn(
                    styles.energy_status_box,
                    styles.energy_status_box_layout
                  )}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item3)}>
            <div className={cn(styles.box4, styles.box4_layout)}>
              <h5
                className={cn(
                  styles.curr_charging_1_txt,
                  styles.curr_charging_1_txt_layout
                )}
              >
                {"Charging"}
              </h5>
              <Gauge
                chargingData={selectChargingFilter}
                name={"charging"}
                color={"#6A9930"}
                dataVal={realTimeData[0]?.chargingPower * -1}
                className={cn(
                  styles.curr_charging_box,
                  styles.curr_charging_box_layout
                )}
              />
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item4)}>
            <div className={cn(styles.box4, styles.box4_layout)}>
              <h5
                className={cn(
                  styles.curr_charging_1_txt,
                  styles.curr_charging_1_txt_layout
                )}
              >
                {"Discharging"}
              </h5>
              <Gauge
                dischargingData={selectDischargingFilter}
                name={"discharging"}
                color={"#0077C0"}
                dataVal={realTimeData[0]?.disChargingPower}
                className={cn(
                  styles.curr_charging_box,
                  styles.curr_charging_box_layout
                )}
              />
            </div>
          </div>
        </div>

        <div className={cn(styles.box, styles.box_layout)}>
          <ChargerTable
            seletId={selectedId}
            dischargingState={checkDischaring}
            chargingState={checkCharging}
            alertState={selectAlert}
            alertFilter={alertData}
            filterChargerData={chargerSelected}
            filterdatas={selectedList}
            tableChargerData={chargerFinalData}
            selectedRecordCb={selectedRecord}
            styles={{ width: "100%", overflowY: "scroll" }}
            className={cn(styles.flex10, styles.flex10_layout)}
          ></ChargerTable>
        </div>

        <div>
          {powerPopup === true ? (
            <PopUp openState={powerBalancePopup} data={energyBalanceData} />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
